import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Capital Project Interest Entry: A financial record tracking interest expenses related to capital projects.',
    name: 'Capital Project Interest Expenses',
    partialId: PartialId.Standard.create('cap_proj_int'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
